<template>
    <div>
        <v-menu
            v-if ="contacts.length > 1"
            bottom
            offset-y
            v-model="menu"
            nudge-top="4"
            nudge-left="4"
            min-width="calc(25% - 30px)"
            max-width="calc(25% - 30px)"
            :close-on-content-click="false"
        >
            <template v-slot:activator="{ on, attrs }">
                <a
                    v-bind  = "attrs"
                    v-on    = "on"
                >
                    <c-site-contact-titel
                        :title  = "title"
                        :length = "contacts.length"
                        :menu   = "menu"
                    >
                        <template slot="right">
                            <slot name="right" />
                        </template>
                    </c-site-contact-titel>
                </a>
            </template>

            <div class="primary pa-1" style="width: calc(100% - 0px)">
                <c-site-contact
                    v-for    = "(contact, index) in contacts"
                    :key     = "index"
                    :class   = "index < contacts.length-1 ? 'mb-1' : ''"
                    :contact = "contact"
                />
            </div>
        </v-menu>

        <div
            v-if ="contacts.length <= 1"
        >
            <c-site-contact-titel
                :title  = "title"
                :length = "contacts.length"
                :menu     = "menu"
            >
                <template slot="right">
                    <slot name="right" />
                </template>
            </c-site-contact-titel>
        </div>

        <c-site-contact
            :contact = "contacts.length > 0 ? contacts[0] : null"
        />
    </div>
</template>

<script>
import CSiteContact      from "@/modules/msd/unit/components/top/CSiteContact";
import CSiteContactTitel from "@/modules/msd/unit/components/top/CSiteContactTitel";

export default {
    name: "CSiteContactRowMenu",

    components: {
        CSiteContactTitel,
        CSiteContact
    }
    ,
    props: {
        title: {
            required: true,
            type    : String
        },

        contacts: {
            required: true,
            type    : Array
        }
    },

    data: () => ({
        menu: false,
    }),

    methods: {
    }
}
</script>

<style scoped>

</style>